export default [
    {
        key: 'code',
        label: 'Código',
        filter: true
    },
    {
        key: 'purpose',
        label: 'Motivo',
        filter: true
    },
    {
        key: 'meeting_date',
        label: 'Fecha de reunión',
        filter: true
    },
    {
        key: 'reported_by.name',
        label: 'Creador de la reunión',
        filter: true
    },
    {
        key: 'meeting_description',
        label: 'Descripción de la reunión',
        filter: true
    },
    {
        key: 'actions',
        label: 'Acciones'
    }
];